<template>
  <div style="overflow: hidden;">
    <LineChart 
      :data="generateChartData()"
      :duration="duration"
      :height="500"
      :x="{ min: 0, max: duration}"
      :y="{ min: 0, max: 15 }"
      :x-unit="'min'"
      :y-unit="'MET'"
      :y-axis-title="$t('CALENDAR_ACTIVITY.activityCharts.apActivityChart.vAxisTitle')"
      :x-axis-title="$t('CALENDAR_ACTIVITY.activityCharts.apActivityChart.xAxisTitle')"
      :y-ticks="[0, 3, 6, 9, 12, 15]" 
      :x-max-seconds="activityInfo.durationInSeconds"
      :display-brushes="activityType === sessionTypes.INDIVIDUAL && activityInfo.status === activityStatus.PROCESSED"
      :on-brush-creation="onBrushCreation"
      :segments="filteredSegments"
      :activity-status="activityInfo.status"
      :trigger-more-details="getMorePreciseAPData"
      :chart-data-medium-precise="mediumPreciseChartDataAP"
      :chart-data-high-precise="highPreciseChartDataAP"
      :chart-data-highest-precise="highestPreciseChartDataAP"
      :player-info="activityInfo"
      :main-line-color="'#F68D2E'"
      :chartMetricsType="'AP'"
      :zoomSelection="zoomSelection"
      :updateZoomSelection="onUpdateSelection" />
  </div>
</template>

<script>
import { ACTIVITY_STATUS } from '@/constants/SessionConsts';
import { SESSION_TYPES } from '@/constants/SessionConsts';
import ChartMixin from '@/mixins/ChartMixin';
import LineChart from '@/components/common/chart/LineChart';

export default {
  name: 'APActivityChart',
  props: [
    'generateChartData',
    'metric',
    'duration',
    'vAxixMaxMinValues',
    'segments',
    'filteredSegments',
    'createActivitySegment',
    'deleteSegment',
    'activityId',
    'brushCreatingTriggered',
    'activityType',
    'activityInfo',
    'fetchMorePreciseActivityData',
    'mediumPreciseChartDataAP',
    'highPreciseChartDataAP',
    'highestPreciseChartDataAP',
    'zoomSelection',
    'onUpdateSelection'
  ],
  data () {
    return {
      numberOfXAxis: 10,
      vAxisTicks: [0, 3, 6, 9, 12],
      vAxisMaxMinValues: { max: 12, min: 0 },
      vAxisBaseline: 0,
      vAxisTitle: this.$t('CALENDAR_ACTIVITY.activityCharts.apActivityChart.vAxisTitle'),
      selection: null,
      sessionTypes: SESSION_TYPES,
      activityStatus: ACTIVITY_STATUS
    }
  },
  computed: {
    xAxisSteps () {
      return this.duration / this.numberOfXAxis
    },
    xTicks () {
      const xTicks = []

      for(var i = 0; i < this.xAxisSteps; i++) {
        xTicks.push(parseInt(i * this.numberOfXAxis))
      }

      xTicks.push(parseInt(this.duration))

      return xTicks
    },
  },
  methods: {
    onBrushCreation ({ selection }) {
      this.brushCreatingTriggered(selection)
    },
    getMorePreciseAPData ({ selection, chartMetricsType }) {
      if(this.activityInfo.status === this.activityStatus.PROCESSED) {
        if(!selection && !selection.length) {
          return;
        }

        const selectionScope = selection[1] - selection[0];

        if(selectionScope <= (5 * 60)) {
          let startOffsetSeconds = selection[0];
          let endOffsetSeconds = selection[1];

          this.fetchMorePreciseActivityData({
            startOffsetSeconds,
            endOffsetSeconds,
            timeInterval: 2,
            chartMetricsType,
            activityId: this.activityId
          });
        } else if(selectionScope <= (15 * 60)) {
          let startOffsetSeconds = selection[0];
          let endOffsetSeconds = selection[1];

          this.fetchMorePreciseActivityData({
            startOffsetSeconds,
            endOffsetSeconds,
            timeInterval: 10,
            chartMetricsType,
            activityId: this.activityId
          });

        } else if(selectionScope <= (30 * 60)) {
          let startOffsetSeconds = selection[0];
          let endOffsetSeconds = selection[1];

          this.fetchMorePreciseActivityData({
            startOffsetSeconds,
            endOffsetSeconds,
            timeInterval: 30,
            chartMetricsType,
            activityId: this.activityId
          });
        }
      }
    }
  },
  mixins: [
    ChartMixin
  ],
  components: {
    LineChart
  }
}
</script>
